import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// The Good Book Company (b_8zv2s38j7b, advertiser -7626954770814929455).
// Real numbers (complete months Nov 2025 – Jul 2026; ~9-month tenure).
// NEW_AND_RETURNING. Reorder ad sales are real, from ADS.BRAND_ORDERS
// ($582 across 3 reorder conversions) — see realBrandData.ts.
// Modest-but-successful archetype: small pooled budget, ~6.2x first-year ROAS.
export const advGoodBookCompany: FaireAdvertiserProfileEntity = {
  token: "adv_good_book_company",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "The Good Book Company",
  brandToken: "b_8zv2s38j7b",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 9,
  budget: {
    totalBudgetDollars: 500,
    sharedBudgetDollars: 500,
    spendingMode: "MAXIMUM",
    nextRenewsAtDate: "2026-09-01",
    nextBillsAtDate: "2026-09-04",
  },
  overview: {
    numCustomersAcquired: 29,
    numReorderConversions: 3,
    numTotalConversions: 32,
    totalAdsSalesDollars: 15078,
    newCustomerAdsSalesDollars: 14496,
    reorderAdsSalesDollars: 582,
    totalAdsSpendDollars: 2427,
    newCustomerAdsSpendDollars: 2296,
    reorderAdsSpendDollars: 131,
    newCustomerBestEstimateFirstYearRoas: 6.31,
    reorderRoas: 4.2,
    combinedFirstYearRoas: 6.2,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 600,
      maxRecommendedBudgetDollars: 1200,
      isEligibleForIncreaseRec: true,
    },
    reorder: {
      minRecommendedBudgetDollars: 100,
      maxRecommendedBudgetDollars: 200,
    },
  },
  campaignTokens: ["camp_gbc_new", "camp_gbc_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-04T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
